import { getAssetPath } from '@/constants/configs';
import {
  defaultConfigs,
  getExtraBasicInfoQuestions as defaultGetExtraBasicInfoQuestions,
  resolveICBWebUrl,
} from '@/constants/tenant-configs/default';

import { QuestionCode } from '@/types/api/pep';
import { AppConfigurations } from '@/types/app-configurations';
import { DocumentType } from '@/types/document';
import { User } from '@/types/user';

import { isBusinessPurposeQuestionEnabled, isMinorUser } from '@/utils/user';

export const guyanaConfigs: AppConfigurations = {
  ...defaultConfigs,
  links: {
    ...defaultConfigs.links,
    privacyPolicyURL: 'https://www.republicguyana.com/about/privacy-policy',
    termsAndConditionsURL:
      'https://republiconline.republictt.com/RBLGuyana/legal.html',
    termsOfUseURL: getAssetPath('/tnc/republiconboard-tnc-guy.pdf'),
    appTermsAndConditionsURL: getAssetPath('/tnc/republiconboard-tnc-guy.pdf'),
    biometricConsentURL: getAssetPath(
      '/bio-consent/republiconboard-biometric-consent-guy.pdf',
    ),
    icbWeb: resolveICBWebUrl(
      'https://republiconlinegy.rfhl.com/TT_RBL_TL.UI/#/administrationGeneral/login',
    ),
    icbIOS: 'https://apps.apple.com/us/app/republicmobile-guyana/id1486014233',
    icbAndroid:
      'https://play.google.com/store/apps/details?id=gy.com.republicbank&pli=1',
    timeSaverURL: 'https://www.republicguyana.com/personal/timesaver-account',
    eFreeURL: 'https://www.republicguyana.com/personal/e-Free',
    savingsPlusURL: 'https://www.republicguyana.com/personal/savings-plus',
  },
  defaultCountryCode: '592',
  locale: 'en-GY',
  isoCode: 'GUY',
  dateFormat: 'dd/MM/yyyy',
  defaultCurrency: 'GYD',
  idCaptureRequirement: 'idCardOrPassport',
  idDocumentTypes: [
    DocumentType.Id,
    DocumentType.Passport,
    DocumentType.IdentityDriverLicense,
  ],
  idTypesWithoutExpiryDate: [
    ...(defaultConfigs.idTypesWithoutExpiryDate || []),
    DocumentType.Id,
  ],
  requiredLocalTIN: true,
  autoApproveUnemployedUsers: true,
  shouldRequireMaritalStatus: false,
  showRiskSectorFlagQuestion: false,
  showSelfEmployedWithRiskSectorFlagQuestion: true,
  existingCustomer: {
    maxAccountsPerType: 2,
  },
  jointAccountRelationshipOptions: [
    { value: 'PARENT', i18nKey: 'minorOthers.form.relationship.parent' },
    {
      value: 'LEGAL_GUARDIAN',
      i18nKey: 'minorOthers.form.relationship.legalGuardian',
    },
  ],
};

export const getExtraBasicInfoQuestions = (user: User) => {
  if (isMinorUser(user)) {
    return defaultGetExtraBasicInfoQuestions(user);
  }
  return {
    ...defaultGetExtraBasicInfoQuestions(user),
    [QuestionCode.AccountPurpose]: {
      enabled: isBusinessPurposeQuestionEnabled(user),
      question: 'questionDrawer.accountPurpose.question',
      priority: 0,
    },
    [QuestionCode.GrossMonthlyIncome]: {
      enabled: user.monthlyIncome === undefined,
      question: 'questionDrawer.expectedGrossMonthlyIncome',
      priority: 4,
    },
    [QuestionCode.FundingSource]: {
      enabled: user.fundingSource === undefined,
      question: 'questionDrawer.sourceOfFunding',
      priority: 5,
    },
  };
};
